module.exports = __webpack_public_path__ + "img/yingyu.b468107d.png";